import { createAsyncThunk } from "@reduxjs/toolkit";
import { type TraineeMergeStrategy } from "@fitness-app/data-models/businessEvents/domain/product/ProductEvents";
import { type AutomationTaskWithoutTriggers } from "@fitness-app/data-models/entities/Automation";
import { getError } from "@fitness-app/utils";

import { type AsyncThunkCreator } from "../../../index";
import { PRODUCT_CLIENT_REDUCER } from "../types";

type Payload = {
  oldEmail: string;
  newEmail: string;
  productId: string;
  tasksForOldEmail: AutomationTaskWithoutTriggers[];
  tasksForNewEmail: AutomationTaskWithoutTriggers[];
  sendEmailNotification: boolean;
  applyToAllProducts?: boolean;
  traineeMergeStrategy?: TraineeMergeStrategy;
};

export const changeProductClientEmail = createAsyncThunk<void, Payload, AsyncThunkCreator<string>>(
  `${PRODUCT_CLIENT_REDUCER}/changeProductClientEmail`,
  async (payload, { rejectWithValue, extra: { productApi, analytics } }) => {
    try {
      await productApi.post("/change-product-client-email", payload);
      analytics.track("change_product_client_email", {
        productId: payload.productId,
        traineeMergeStrategy: payload.traineeMergeStrategy,
      });
    } catch (e) {
      // Surface the backend message (e.g. 409 conflict for non-client / shared-account / duplicate)
      // so the UI can show a meaningful reason instead of a generic error.
      return rejectWithValue(getError(e).message);
    }
  },
);
